import React, { useEffect, useState } from 'react';
import CandleStickChart from './CandlestickChart.js';
import tableHelpers from '../helpers/TableHelpers.js'
import RichTable from '../components/richTable/RichTable.jsx'
import ExpectancyChart from '../components/ExpectancyChart.js';
import Indicators from '../positions/Indicators.js';
import OHLCBarChart from '../components/OHLCBarChart.js'
import AlgoDrawer from '../algos/AlgoDrawer.js'
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { Link } from 'react-router-dom'
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import IndicatorSelector from './IndicatorSelector.js';
import StickySettings from '../helpers/StickySettings.js';

function StockQuickLook(props) {

    const [activeTrades, setActiveTrades] = useState([]);
    const [quote, setQuote] = useState(null);
    const [algos, setAlgos] = useState([]);
    const [indicators, setIndicators] = useState([]);
    const [showTradesOnChart, setShowTradesOnChart] = useState(false);
    const [chartTimeframe, setChartTimeframe] = useState(1);
    const [showVolumeOnChart, setShowVolumeOnChart] = useState(false);
    const [allAlgos, setAllAlgos] = useState([]);
    const [allActiveTrades, setAllActiveTrades] = useState([]);
    const [patterns, setPatterns] = useState([]);
    const smaIndicators = [
        { type: 'sma', id: 'sma20', location: 'upper', config: { period: 20 } },
        { type: 'sma', id: 'sma50', location: 'upper', config: { period: 50 } },
        { type: 'sma', id: 'sma200', location: 'upper', config: { period: 200 } }
    ];
    const [selectedIndicators, setSelectedIndicators] = useState(StickySettings.getJSON('stockQuickLookIndicators', [...smaIndicators]));

    useEffect(() => {
        StickySettings.setJSON('stockQuickLookIndicators', selectedIndicators);
    }, [selectedIndicators]);

    useEffect(() => {
        (async function () {

            setActiveTrades([])
            let trades = await (await fetch(`/api/activeTrades?planId=` + props.planId)).json()
            console.log("activeTrades", trades);
            setActiveTrades(trades);

            let quoteData = await (await fetch(`/api/quote?symbols=` + props.symbol)).json()
            console.log("quoteData", quoteData);
            if (quoteData && quoteData.length > 0)
                setQuote(quoteData[0]);

            let algoStats = await (await fetch(`/api/algoStats?planId=` + props.planId + "&all=0")).json();
            setAlgos(algoStats);

            let indicators = await (await fetch(`/api/indicators`)).json();
            setIndicators(indicators.indicators || []);
            setPatterns(indicators.patterns || []);
        })();
    }, [props.planId, props.symbol]);

    let start = new Date();
    start.setMonth(start.getMonth() - 60);
    let dateString = start.getUTCFullYear() + "-" + (start.getMonth() + 1) + "-1";

    function getTrades() {
        activeTrades.forEach(trade => {
            trade.profit = ((trade.current_price - trade.close) / trade.close * 100);
        })
        return activeTrades.filter(t => t.trade_symbol === props.symbol)
    }

    function profitChartFormatter(cell, row) {
        return <ExpectancyChart width={250} profit={row.profit} avgWin={row.avg_win} avgLoss={row.avg_loss} />
    }

    function tradeDescriptionFormatter(cell, row) {
        return <div className='sameline'>
            {tableHelpers.percentFormatterNoDecimals(row.allocation)}
            &nbsp;<AlgoDrawer link={row.display_name} planId={props.planId} accountId={props.accountId} userId={props.userId} mobileView={props.mobileView} algoId={row.algoId} role={props.role} />
        </div>
    }

    function getStats() {
        return algos.filter(a => a.trade_symbol === props.symbol)
            .filter(a => a.years === 5);
    }

    function todayChangeFormatter(quote) {
        if (quote) {
            let highChange = (quote.high - quote.pclose) / quote.pclose * 100;
            let lowChange = (quote.low - quote.pclose) / quote.pclose * 100;
            let openChange = (quote.open - quote.pclose) / quote.pclose * 100;
            let change = quote.percentChange;
            console.log("quote", quote);

            return (
                <OHLCBarChart width="80px" hideLabels={true} high={highChange} low={lowChange} open={openChange} close={change} />
            );
        } else return "";
    }

    function algoLinkFormatter(cell, row) {
        let algoid = row.algoId;

        return (
            <AlgoDrawer link={row.display_name} planId={props.planId} accountId={props.accountId} userId={props.userId} mobileView={props.mobileView} algoId={algoid} role={props.role} />
        )
    }

    function allAlgosLinkFormatter(cell, row) {
        let algoid = row.algoId;
        let activeTrade = allActiveTrades.find(t => t.algoId === algoid);

        return (
            <div className='sameline'>
                {activeTrade ? "🚨" : null}<AlgoDrawer link={row.display_name} planId={props.planId} accountId={props.accountId} userId={props.userId} mobileView={props.mobileView} algoId={algoid} role={props.role} />
            </div>
        )
    }

    async function showAllAlgos() {
        let algos = await (await fetch(`/api/algoStatsBySymbol?years=5&symbol=` + props.symbol)).json()
        console.log("allAlgos", algos);
        setAllAlgos(algos);

        let trades = await (await fetch(`/api/allActiveTrades`)).json()
        console.log("allTrades", trades);
        setAllActiveTrades(trades);
    }

    return (
        <div>
            <div className='sameline'>
                <h4 style={{ display: 'flex' }}>{props.symbol}&nbsp;&nbsp;{todayChangeFormatter(quote)}</h4>
                {quote && quote.postMarketPercentChange ? <>Ext Hours: {tableHelpers.percentChangeFormatter((quote.postMarketPercentChange))}</> : null}
            </div>
            <Indicators hideSymbol={true} symbols={[props.symbol]} mobileView={true} hideReload={true} />
            <div style={{ backgroundColor: 'white' }}>
                <center>
                    <ToggleButtonGroup
                        value={chartTimeframe}
                        exclusive
                        color="primary"
                        size="small"
                        onChange={(e) => setChartTimeframe(parseInt(e.target.value))}
                    >
                        <ToggleButton value={1}>Daily</ToggleButton>
                        <ToggleButton value={2}>Weekly</ToggleButton>
                    </ToggleButtonGroup>
                </center>
            </div>
            <CandleStickChart indicators={selectedIndicators} showMovingAverage={false} showVolume={showVolumeOnChart} timeframe={chartTimeframe} initialVisibleBars={props.mobileView ? 33 : 66} startDate={dateString} showAveragePrice={showTradesOnChart ? true : false} symbol={props.symbol} trades={showTradesOnChart ? getTrades() : []} width={props.mobileView ? 360 : 450} height={250} hideTooltip={true} />
            <input type="checkbox" checked={showTradesOnChart} onChange={(e) => setShowTradesOnChart(!showTradesOnChart)} /> Show Active Trades and avg price
            <br></br>
            <input type="checkbox" checked={showVolumeOnChart} onChange={(e) => { setShowVolumeOnChart(e.target.checked); }} /> Show Volume
            <br></br>
            <IndicatorSelector indicators={indicators} selectedIndicators={selectedIndicators} setSelectedIndicators={setSelectedIndicators} patterns={patterns} />
            <br></br>
            {getTrades().length ?
                <>
                    <h5>Active Trades</h5>
                    <RichTable data={getTrades()} className="table-striped table-hover table-condensed" mappers={[
                        { title: 'Trade', field: 'allocation', formatter: tradeDescriptionFormatter },
                        { title: 'Profit', field: 'profit', formatter: profitChartFormatter },
                    ]} />
                </>
                : null}

            <br />
            <h5>Plan Algos (5Y Backtest)</h5>
            <RichTable data={getStats()} className="table-striped table-hover table-condensed" mappers={[
                { title: 'Algo', field: 'display_name', formatter: algoLinkFormatter, sorters: false },
                { title: 'Alloc', field: 'percentage', formatter: tableHelpers.percentFormatterNoDecimals, sorters: false },
                { title: 'Win %', field: 'winning_percentage', formatter: tableHelpers.percentFormatterNoDecimals, sorters: false },
                { title: 'W/L Ratio', field: 'win_loss_ratio', formatter: tableHelpers.decimalFormatter, sorters: false },
                { title: 'Robust', field: 'algo_robustness_overall', formatter: tableHelpers.decimalFormatter, sorters: false },
            ]} />

            {allAlgos.length === 0 ?
                <h5><Link onClick={() => showAllAlgos()}>Show All Algos</Link>&nbsp;<ExpandCircleDownIcon onClick={() => showAllAlgos()} /></h5>
                : null}

            {allAlgos.length ?
                <>
                    <br></br>
                    <h5>All Algos</h5>
                    <RichTable data={allAlgos} className="table-striped table-hover table-condensed" mappers={[
                        { title: 'Algo', field: 'display_name', formatter: allAlgosLinkFormatter, sorters: true },
                        { title: 'Win %', field: 'winning_percentage', formatter: tableHelpers.percentFormatterNoDecimals, sorters: true },
                        { title: 'W/L Ratio', field: 'win_loss_ratio', formatter: tableHelpers.decimalFormatter, sorters: true },
                        { title: 'Robust', field: 'algo_robustness_overall', formatter: tableHelpers.decimalFormatter, sorters: true },
                    ]} />
                </>
                :
                null}
        </div>
    )
}

export default StockQuickLook;